import { Injectable, Injector } from "@angular/core";
import { MfBaseService, MfMenuItem, MfTableQueryFilterService, MfTypeInfo } from "@pattonair/material-framework";
import { AucRoleFeatureTypes } from "../common/feature.type";
import { AucIconsConfig } from "../config";
import { AucActionCardAction } from "../home/home.component";
import { AucRouteNames } from "../route.names";

const TYPE_INFO: MfTypeInfo = { className: "AucSideMenuService" };

@Injectable({ providedIn: "root" })
export class AucSideMenuService extends MfBaseService {
  public constructor(
    protected override _injector: Injector,
    protected _tableQueryFilterService: MfTableQueryFilterService,
  ) {
    super(TYPE_INFO, _injector);
  }


  public getActionCardActions(features: AucRoleFeatureTypes[], config: AucIconsConfig): AucActionCardAction[] {
    const actions: AucActionCardAction[] = [];

    actions.push({
      title: "Auctions",
      description: "Purchase from our extensive range of auctions",
      icon: config.auctionIcon,
      redirectUrl: AucRouteNames.routeAuctionsList,
    });

    actions.push({
      title: "My Bids",
      description: "View auctions you have bid on",
      icon: config.bidsIcon,
      redirectUrl: AucRouteNames.routeBidList,
    });

    actions.push({
      title: "My Won Auctions",
      description: "View your won auctions",
      icon: config.wonIcon,
      redirectUrl: AucRouteNames.routeWonList,
    });

    return actions;
  }


  public getMenuItems(features: AucRoleFeatureTypes[], config: AucIconsConfig): MfMenuItem[] {
    return this.getActionCardActions(features, config).map((action) => ({
      label: action.title,
      tooltip: action.description,
      icon: action.icon,
      routerLink: { link: action.redirectUrl, params: action.redirectUrl }
    }) as MfMenuItem);
  }
}